/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
  GetApiV1PersonIdAttachmentsClassStudentsPathParams,
  GetApiV1PersonIdAttachmentsClassStudentsQueryParams,
  GetApiV1PersonIdAttachmentsClassStudents401,
  GetApiV1PersonIdAttachmentsClassStudents404,
  GetApiV1PersonIdAttachmentsClassStudents500,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsClassStudents.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdAttachmentsClassStudents } from "../../clients/personDocumentsController/getApiV1PersonIdAttachmentsClassStudents.ts";

export const getApiV1PersonIdAttachmentsClassStudentsQueryKey = (
  id: GetApiV1PersonIdAttachmentsClassStudentsPathParams["id"],
  params?: GetApiV1PersonIdAttachmentsClassStudentsQueryParams,
) =>
  [
    {
      url: "/api/v1/person/:id/attachments/class-students",
      params: { id: id },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1PersonIdAttachmentsClassStudentsQueryKey = ReturnType<
  typeof getApiV1PersonIdAttachmentsClassStudentsQueryKey
>;

export function getApiV1PersonIdAttachmentsClassStudentsQueryOptions(
  id: GetApiV1PersonIdAttachmentsClassStudentsPathParams["id"],
  params?: GetApiV1PersonIdAttachmentsClassStudentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdAttachmentsClassStudentsQueryKey(id, params);
  return queryOptions<
    GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachmentsClassStudents401
      | GetApiV1PersonIdAttachmentsClassStudents404
      | GetApiV1PersonIdAttachmentsClassStudents500
    >,
    GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdAttachmentsClassStudents(id, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna as turmas em que a pessoa está matriculada (CourseRegistration). Pode filtrar por empresa via companyId. **(Requer Authorization para autenticação)**
 * @summary Turmas (ClassStudent) do aluno para o dropdown da aba Documentos (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/attachments/class-students}
 */
export function useGetApiV1PersonIdAttachmentsClassStudents<
  TData = GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
  TQueryData = GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdAttachmentsClassStudentsQueryKey,
>(
  id: GetApiV1PersonIdAttachmentsClassStudentsPathParams["id"],
  params?: GetApiV1PersonIdAttachmentsClassStudentsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdAttachmentsClassStudentsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdAttachmentsClassStudents401
          | GetApiV1PersonIdAttachmentsClassStudents404
          | GetApiV1PersonIdAttachmentsClassStudents500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonIdAttachmentsClassStudentsQueryKey(id, params);

  const query = useQuery(
    {
      ...getApiV1PersonIdAttachmentsClassStudentsQueryOptions(
        id,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdAttachmentsClassStudents401
      | GetApiV1PersonIdAttachmentsClassStudents404
      | GetApiV1PersonIdAttachmentsClassStudents500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
